export default "__VITE_ASSET__D922cfrU__"